import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
    standalone : true,
    imports    : [RouterOutlet],
})
export class AppComponent
{
    /**
     * Constructor
     */
    constructor(
        // private signalrService: SignalRService
    )
    {
    }

    ngOnInit() {
        // // Sostituisci con il tuo URL e token JWT se necessario
        // var hubUrl = environment.NOTIFICATION_WS_URL;
        // if (!!hubUrl)
        //     this.signalrService.startConnection(hubUrl);
    }
}
